import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  const goToAbout = (e) => {
    e.preventDefault();
    window.location.href = "/about";
  };
  const goToHome = (e) => {
    e.preventDefault();
    window.location.href = "/";
  };
  const goToShop = (e) => {
    e.preventDefault();
    window.location.href = "/shop";
  };
  const goToContact = (e) => {
    e.preventDefault();
    window.location.href = "/contact";
  };
  const goToWishlist = (e) => {
    e.preventDefault();
    window.location.href = "/wishlist";
  };
  const goToAccount = (e) => {
    e.preventDefault();
    window.location.href = "/account";
  };

  return (
    <footer className="ltn__footer-area  ">
      <div className="footer-top-area  section-bg-2 plr--5">
        <div className="container-fluid">
          <div className="row">
            <div className="col-xl-3 col-md-6 col-sm-6 col-12">
              <div className="footer-widget footer-about-widget">
                <div className="footer-logo">
                  <div className="site-logo">
                    <img
                      src="img/sunrise_logo_white.png"
                      alt="Logo"
                      style={{ width: "60%", height: "60%" }}
                    />
                  </div>
                </div>
                <p>
                  Sunrise Medical Equipment is a trusted provider of
                  high-quality medical devices and healthcare solutions. We are
                  committed to enhancing patient care by offering reliable,
                  innovative, and affordable equipment for hospitals, clinics,
                  and home healthcare settings.
                </p>
                <div className="footer-address">
                  <ul>
                    <li>
                      <div className="footer-address-icon">
                        <i className="icon-placeholder" />
                      </div>
                      <div className="footer-address-info">
                        <p className="text-white">
                          Sardar Patel Ringroad, Zundal, Ahmedabad
                        </p>
                      </div>
                    </li>
                    <li>
                      <div className="footer-address-icon">
                        <i className="icon-call" />
                      </div>
                      <div className="footer-address-info">
                        <p>
                          <Link to="tel:+9879793195" className="text-white">
                            +9879793195
                          </Link>
                        </p>
                      </div>
                    </li>
                    <li>
                      <div className="footer-address-icon ">
                        <i className="icon-mail" />
                      </div>
                      <div className="footer-address-info">
                        <p>
                          <Link
                            to="mailto:example@example.com"
                            className="text-white"
                          >
                            info@sunrisemeditechsystems.com
                          </Link>
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="ltn__social-media mt-20">
                  <ul>
                    <li>
                      <Link to="#" title="Facebook">
                        <i className="fab fa-facebook-f" />
                      </Link>
                    </li>
                    <li>
                      <Link to="#" title="Twitter">
                        <i className="fab fa-twitter" />
                      </Link>
                    </li>
                    <li>
                      <Link to="#" title="Linkedin">
                        <i className="fab fa-linkedin" />
                      </Link>
                    </li>
                    <li>
                      <Link to="#" title="Youtube">
                        <i className="fab fa-youtube" />
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-xl-2 col-md-6 col-sm-6 col-12">
              <div className="footer-widget footer-menu-widget clearfix">
                <h4 className="footer-title">Company</h4>
                <div className="footer-menu">
                  <ul>
                    <li>
                      <a
                        href="/about"
                        onClick={goToAbout}
                        className="text-light-white"
                      >
                        About Us
                      </a>
                    </li>
                    <li>
                      <a
                        href="/shop"
                        onClick={goToShop}
                        className="text-light-white"
                      >
                        All Products
                      </a>
                    </li>
                    <li>
                      <a
                        href="/contact"
                        onClick={goToContact}
                        className="text-light-white"
                      >
                        Contact us
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-xl-2 col-md-6 col-sm-6 col-12">
              <div className="footer-widget footer-menu-widget clearfix">
                <h4 className="footer-title">Services</h4>
                <div className="footer-menu">
                  <ul>
                    <li>
                      <a
                        href="/"
                        onClick={goToHome}
                        className="text-light-white"
                      >
                        Home
                      </a>
                    </li>
                    <li>
                      <a
                        href="/wishlist"
                        onClick={goToWishlist}
                        className="text-light-white"
                      >
                        Contact us
                      </a>
                    </li>
                    <li>
                      <Link to="/login" className="text-light-white">
                        Login
                      </Link>
                    </li>
                    <li>
                      <a
                        href="/account"
                        onClick={goToAccount}
                        className="text-light-white"
                      >
                        My account
                      </a>
                    </li>                   
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-xl-2 col-md-6 col-sm-6 col-12">
              <div className="footer-widget footer-menu-widget clearfix">
                <h4 className="footer-title">Customer Care</h4>
                <div className="footer-menu">
                  <ul>
                    <li>
                      <Link to="/account" className="text-light-white">
                        My account
                      </Link>
                    </li>
                    <li>
                      <Link to="/wishlist" className="text-light-white">
                        Wish List
                      </Link>
                    </li>
                    <li>
                      <Link to="/contact" className="text-light-white">
                        Contact us
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-md-6 col-sm-12 col-12">
              <div className="footer-widget footer-newsletter-widget">
                <h4 className="footer-title">Newsletter</h4>
                <p>
                  Subscribe to our weekly Newsletter and receive updates via
                  email.
                </p>
                <div className="footer-newsletter">
                  <form action="#">
                    <input
                      type="email"
                      name="email"
                      placeholder="Email*"
                      style={{ width: "100%" }}
                    />
                    <div className="btn-wrapper">
                      <button className="theme-btn-1 btn" type="submit">
                        <i className="fas fa-location-arrow" />
                      </button>
                    </div>
                  </form>
                </div>
                {/* <h5 className="mt-30">We Accept</h5>
                  <img src="img/icons/payment-4.png" alt="Payment_image" /> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="ltn__copyright-area ltn__copyright-2 section-bg-7  plr--5">
        <div className="container-fluid ltn__border-top-2">
          <div className="row">
            <div className="col-md-6 col-12">
              <div className="ltn__copyright-design clearfix">
                <p>
                  All Rights Reserved @ Company{" "}
                  <span className="current-year" />
                </p>
              </div>
            </div>
            <div className="col-md-6 col-12 align-self-center">
              <div className="ltn__copyright-menu text-end">
                <ul>
                  <li>
                    <a
                      href="/docs/terms_conditions.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white"
                    >
                      Terms &amp; Conditions
                    </a>
                  </li>
                  <li>
                    <a
                      href="/docs/privacy_policy.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                       className="text-white"
                    >
                      Privacy &amp; Policy
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="preloader d-none" id="preloader">
        <div className="preloader-inner">
          <div className="spinner">
            <div className="dot1" />
            <div className="dot2" />
          </div>
        </div>
      </div>
    </footer>
  );
}
